import type { $Fetch } from 'ofetch';
import type { DocumentoGateway } from '@/application/port/out/DocumentoGateway';
import type { Documento, DocumentoTipo } from '@/domain/model/Documento';
import type { Page } from '@/domain/model/Page';
import type { ApiResponse } from '@/infrastructure/http/types';
import { assertApiSuccess } from '@/infrastructure/http/assertApiSuccess';

export class HttpDocumentoGateway implements DocumentoGateway {
  constructor(private readonly client: $Fetch) {}

  async listByAluno(alunoId: string): Promise<Documento[]> {
    const res = await this.client<ApiResponse<Documento[]>>(
      `/api/v1/documentos/aluno/${encodeURIComponent(alunoId)}`, { method: 'GET' });
    assertApiSuccess(res);
    return res.data;
  }

  async listTipos(): Promise<DocumentoTipo[]> {
    // BE retorna Spring Page<T>; aqui achatamos pra T[] preservando contrato port-out.
    // Sem isso DocumentosTab.vue quebra com tipos.value.filter(...) — Page<T> não é array.
    const res = await this.client<ApiResponse<Page<DocumentoTipo>>>(
      '/api/v1/admin/documento-tipos', { method: 'GET', params: { page: 0, size: 200 } });
    assertApiSuccess(res);
    return res.data.content;
  }
}
